export const URL = {
    //dev_url : "https://phleboservice.medibuddy.in/",
    //dev_url : "https://phleboservice.medibuddy.in/dev/",
    // providercore_url : (window.location.hostname === 'phlebo.medibuddy.in') ?  "https://providercore.medibuddy.in/" : "https://providernode-stage.medibuddy.in/",
    providercore_url : process.env.REACT_APP_PROVIDERCORE_URL,
    dev_url : process.env.REACT_APP_API_URL,
    s3_upload_image_url : "https://providercore.medibuddy.in/provider/Uploadfile",
    mb_wapi : process.env.REACT_APP_WAPI_URL,
    REACT_FUSER_URL : process.env.REACT_APP_FUSER_URL,
    REACT_VIDEO_MB : process.env.REACT_APP_VIDEO_MB,
    REACT_APP_API_BANNERS:process.env.REACT_APP_BANNERS_URL,
    OMS: "https://oms.medibuddy.in"
}

export const labsDetails = {
  checkoutItems : {},
  userLoginDetails: {},
};

export const platformsSupportedForPhleboUpsell = ["web", "androidmb","android","ios","iosmb","mobilesite","mweb","phlebo"]

export const USER = {
    access_token : localStorage.getItem("access_token") ?  localStorage.getItem("access_token") : '',
    user : localStorage.getItem('user_details') ? JSON.parse(localStorage.getItem("user_details")) : [],
    orderDetails : localStorage.getItem('order_details') ? JSON.parse(localStorage.getItem('order_details')) : null,
}

export const ABHIErId = ["451469"]
export const merCompulsoryPackage = ["MB0381","MB0382","MB0386","MB0575"]
export const retailCorporate = "1018900"
export const platform = "phlebo"
export const otherRelationId=23;

export const merFormHtmlTemplate = `<html lang='en'>
<head>
  <meta charset='UTF-8'>
  <style>
    body {
      margin-top: 10%;
      margin-bottom: 10%;
      font-family: Helvetica, sans-serif;
    }

    .heading {
      text-align: center;
    }

    .logo {
      height: 80
    }

    .medibuddy-header .first-half {
      color: #1878F2;
    }

    .medibuddy-header .second-half {
      color: #F40208;
    }

    .adityabirla-header {
      text-decoration: underline;
    }

    table {
      width: 80%;
      margin: 5%;
    }

    table th {
      width: 50%;
    }

    table,
    th,
    td {
      border: 1px solid black;
      border-collapse: collapse;
      padding: 10px;
    }

    .userinfo-table,
    .merinfo-table {
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  </style>
</head>

<body>
  <div class='heading'>
    <img src="https://www.medibuddy.in/assets/logos/medibuddyWithName.svg" alt="MediBuddy" class="logo">
    <h2 class='adityabirla-header'>
      <%= heading %>
    </h2>
  </div>

  <table class='userinfo-table'>
    <tr>
      <th>Name:</th>
      <td><%= nameOfTheEmployee %></td>
    </tr>
    <tr>
      <th>Mobile #:</th>
      <td><%= mobileNumber %></td>
    </tr>
    <tr>
      <th>Member Id:</th>
      <td><%= memberId %></td>
    </tr>
  </table>

  <table class='merinfo-table'>
    <tr>
      <th>Height (in cm)</th>
      <td><%= height %></td>
    </tr>
    <tr>
      <th>Weight (in kgs)</th>
      <td><%= weight %></td>
    </tr>
    <tr>
      <th>Systolic BP (mm Hg)</th>
      <td><%= BPSystolic %></td>
    </tr>
    <tr>
      <th>Diastolic BP (mm Hg)</th>
      <td><%= BPDiastolic %></td>
    </tr>
    <tr>
      <th>BMI</th>
      <td><%= bmi %></td>
    </tr>
  </table>
</body>

</html>`
